module.exports = __webpack_public_path__ + "img/checked.14af72aa.svg";